module.exports = __webpack_public_path__ + "img/architectural-evolution-1.4038ee34.png";